import {AbstractEvent} from "@/modules/base/events";

export default class AfterGameLoadedEvent extends AbstractEvent {
}
